import { useState } from "react";
import Navbar from "@/components/homepage/Navbar";
import HomepageFooter from "@/components/homepage/HomepageFooter";
import HomepageLeadModal from "@/components/homepage/HomepageLeadModal";
import HomepageStickyCta from "@/components/homepage/HomepageStickyCta";
import ResourceHero from "@/components/allresource/Hero";
import VideoLibraryGrid from "@/components/allresource/VideoLibraryGrid";
import { FORM_CONFIGS } from "@/config/forms";
import InviteSection from "@/components/homepage/InviteSection";

const AllResource = () => {
  const [leadModal, setLeadModal] = useState<{ open: boolean; email: string }>({
    open: false,
    email: "",
  });

  const openLeadModal = (email: string) => {
    setLeadModal({ open: true, email });
  };

  const closeLeadModal = () => {
    setLeadModal({ open: false, email: "" });
  };

  return (
    <main
      className="flex min-h-svh w-full flex-col bg-black pb-24 text-white max-md:pb-[calc(5rem+env(safe-area-inset-bottom,0px))]"
      style={{ fontFamily: "var(--font-fira)" }}
    >
      <Navbar />
      <ResourceHero />
      <VideoLibraryGrid />
      <InviteSection />
      <HomepageFooter onEmailContinue={openLeadModal} />
      <HomepageStickyCta
        heroSectionId="all-resources-hero"
        ctaSectionId="all-resources-cta"
        marketingBasePath="/all-resources"
        onEmailContinue={openLeadModal}
      />
      <HomepageLeadModal
        open={leadModal.open}
        initialEmail={leadModal.email}
        onClose={closeLeadModal}
        formConfig={FORM_CONFIGS.resources}
      />
    </main>
  );
};

export default AllResource;
